import styled, { keyframes } from "styled-components";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const Container = styled.div`
  margin-top: 100px;
`;

export const Load = styled.div`
  border: 2px solid #f0f0f0;
  border-top: 2px solid #5f5f5f;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: ${spin} 1s linear infinite;
`;
